import { Dayjs } from 'dayjs';

export const timeToBaseDate = (time: Dayjs, baseDate: Dayjs) => {
  return time
    .set('year', baseDate.get('year'))
    .set('month', baseDate.get('month'))
    .set('date', baseDate.get('date'));
};
